import {
  generateMarkerScrollHandle,
  generateScrollByStepHandle,
  generateScrollHandle,
  generateKeydownHandle,
  resetScrollHandle,
} from './utils';

class AbstractCarousel {
  constructor({ gallery, prefixClassName, gap, features, extraToggleClass }) {
    this.carousel = gallery.querySelector(`.${prefixClassName}__container`);
    this.prevBtn = gallery.querySelector(`.${prefixClassName}__arrow-btn--left`);
    this.nextBtn = gallery.querySelector(`.${prefixClassName}__arrow-btn--right`);
    this.markersContainer = gallery.querySelector(`.${prefixClassName}__markers`);
    this.markers = gallery.querySelectorAll(`.${prefixClassName}__markers a[href*="carousel_"]`);
    this.features = {
      keydown: features?.keydown || false,
    };
    this.prefixClassName = prefixClassName;
    this.gap = gap;
    this.extraToggleClass = extraToggleClass;
  }

  init() {
    throw new Error("Method 'init()' must be implemented");
  }

  #buildHandlers() {
    // Generate bunch of types of handlers for standard gallery
    this.handlers = {
      markerScrollHandle: generateMarkerScrollHandle(this.carousel),
      scrollByStepHandle: generateScrollByStepHandle(this.carousel, this.gap),
      scrollHandle: generateScrollHandle({
        carouselElement: this.carousel,
        prevBtn: this.prevBtn,
        nextBtn: this.nextBtn,
        markersElements: this.markers,
        toggleClass: `${this.prefixClassName}__marker--active`,
        gap: this.gap,
        extraToggleClass: this.extraToggleClass || '',
      }),
      keydownHandle: generateKeydownHandle(this.carousel),
    };
  }

  bindAbstractCarouselEvents() {
    this.#buildHandlers();
    // Sets plenty of kind of events for abstract carousel
    this.markers.forEach((marker) => marker.addEventListener('click', this.handlers.markerScrollHandle));
    this.carousel.addEventListener('scroll', this.handlers.scrollHandle);
    // In case, Gallery poses just one single image, we won't need to attach events on prevBtn and nextBtn
    // they aren't rendered under this scenario. We don't also need to attach a 'keydown' event under this case
    this.prevBtn?.addEventListener('click', this.handlers.scrollByStepHandle);
    this.nextBtn?.addEventListener('click', this.handlers.scrollByStepHandle);
    this.features.keydown &&
      this.prevBtn &&
      this.nextBtn &&
      document.addEventListener('keydown', this.handlers.keydownHandle);
  }

  // Provide an indiviual interface to turn on 'keydown' event on carousel
  enableKeydownEvent() {
    document.addEventListener('keydown', this.handlers.keydownHandle);
  }

  // Provide an indiviual interface to turn off 'keydown' event on carousel
  disableKeydownEvent() {
    document.removeEventListener('keydown', this.handlers.keydownHandle);
  }

  // Dispose an interface to remove all previous events attached to abstract class
  closeAbstractCarouselEvents() {
    this.markers.forEach((marker) => marker.removeEventListener('click', this.handlers.markerScrollHandle));
    this.carousel.removeEventListener('scroll', this.handlers.scrollHandle);
    // In case, Gallery poses just one single image, we won't need to dettach events on prevBtn and nextBtn buttons because they shouldn't be attached
    this.prevBtn?.removeEventListener('click', this.handlers.scrollByStepHandle);
    this.nextBtn?.removeEventListener('click', this.handlers.scrollByStepHandle);
    // It can safetely be executed. Doesn't matter if it was not attached previously above
    document.removeEventListener('keydown', this.handlers.keydownHandle);
  }

  // Dispose an interface to set all markers
  setMarkers() {
    this.markers = this.markersContainer.querySelectorAll(`a[href*="carousel_"]`);
  }

  // Come back to 0 the carousel scrolling
  resetNavigation() {
    resetScrollHandle({
      markersElements: this.markers,
      prevBtn: this.prevBtn,
      nextBtn: this.nextBtn,
      toggleClass: `${this.prefixClassName}__marker--active`,
      extraToggleClass: this.extraToggleClass,
    });
  }
}

export default AbstractCarousel;
